import { TFuelLevyType, TRateCardFuelLevies, TRateCardFuelLevy } from '@types';
import { getSelectedFuelLevy } from './getSelectedFuelLevy';

export const replaceSelectedFuelLevy = (
	fuelLevies: TRateCardFuelLevies | null | undefined,
	type: TFuelLevyType,
	fuelLevyId: string | null | undefined,
	levy: TRateCardFuelLevy | null,
): TRateCardFuelLevies => {
	const current = { customer_levies: [], ...fuelLevies };

	if (type !== 'customer') {
		return { ...current, [type]: levy };
	}

	const selected = getSelectedFuelLevy(current, type, fuelLevyId);
	const index = current.customer_levies.findIndex((candidate) => candidate.id === selected?.id);
	if (index < 0) {
		return levy ? { ...current, customer_levies: [levy] } : current;
	}

	const customer_levies = [...current.customer_levies];
	customer_levies[index] = levy as TRateCardFuelLevy;
	return { ...current, customer_levies };
}
